import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import Button from '../button'
import './_confirm.scss'

// react-modal throws when the selector matches nothing, so only set it where the app root exists
if (document.getElementById('root')) Modal.setAppElement('#root');

function Confirm({ title, copy, isOpen, cancelText, confirmText, onOk = () => {}, onCancel = () => {}, testId }) {
  // The below needs to be excluded because of tests, the Modal component fails in test and the only
  // way is to add the ariaHideApp, which is added conditionally if node env is test

  // istanbul ignore next
  const ariaHideApp = process.env.NODE_ENV === 'test' ? false : true;
  return (
    <div>
      <Modal
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        shouldFocusAfterRender
        shouldReturnFocusAfterClose
        isOpen={isOpen}
        ariaHideApp={ariaHideApp}
        style={{
          overlay: { background: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center' },
          content: { maxBlockSize: '90vh', inlineSize: 'calc(100% - 32px)', maxInlineSize: '360px', position: 'static', padding: 0, borderRadius: '5px' }
        }}
      >
        <div className="confirm" data-testid={testId}>
          {!cancelText && !confirmText && (
            <button data-testid="x" className="confirm__close" onClick={onCancel}>
              <svg role="presentation" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.34118 0L0 1.34094L6.65739 8.00095L0.00190258 14.6591L1.34308 16L7.99762 9.34189L14.6579 15.9962L15.999 14.6553L9.3388 8.00095L16 1.34475L14.6598 0.00380421L7.99762 6.65906L1.34118 0Z" fill="#323232"/>
              </svg>
            </button>
          )}
          {!!title && <h2 className="confirm__title">{title}</h2>}
          {!!copy && <p className="confirm__copy" dangerouslySetInnerHTML={{__html: copy}} />}
          {(cancelText || confirmText) && <div className="confirm__actions">
            {cancelText && <Button onClick={onCancel} testId="modal-cancel" theme="outline" className="confirm__action">{cancelText}</Button>}
            {confirmText && <Button onClick={onOk} testId="modal-confirm" className="confirm__action">{confirmText}</Button>}
          </div>}
        </div>
      </Modal>
    </div>
  )
}


Confirm.propTypes = {
  title: PropTypes.string,
  copy: PropTypes.string,
  isOpen: PropTypes.bool,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  testId: PropTypes.string
}

export default Confirm
